import React from 'react'
import PropTypes from 'prop-types'
import $ from 'jquery'
import '../../utility/csrf'
import GlobalBanner from '../../components/globalBanner'
import AmountWrapper from '../../components/amountWrapper'
import SubHeader from '../../components/subHeader'
import NextButton from '../../components/nextButton'
import CancelAndReturn from '../../components/cancelAndReturn'
import GuestButton from '../../components/guestButton'
import RecurringCheckBox from '../../components/recurring-checkbox'

import templateData from '../../utility/getTemplateData'

import appStore from '../../stores/AppStore'
import appActions from '../../actions/AppActions'

import {
	handleLogIn,
	addShake,
	handleGuest,
	handleTokenReuse,
	validateDonationAmountForUS
} from '../../utility/helper'
import * as amountUtils from '../../components/amount/amountUtils';

import * as FPT from '../../utility/fpt'
import { localsMessages } from '../../utility/getTemplateData'
const messages = localsMessages('common/amount')

let currentState = templateData.currentState

class LandingPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			hasLogo: templateData.hasLogo,
			subHeaderLabel: templateData.donationName,
			orgName: templateData.charityName,
			donationId: templateData.donationId,
			guestRedirectUrl: templateData.guestRedirectUrl,
			donateDisabled: false,
			recurringEnabled: templateData.recurringEnabled,
			recurringStatus: templateData.recurringStatus === 'checked',
			recurringHelpText: '',
			recurringLabel: 'Make this a monthly donation',
			rpContinue: false
		};
	}

	componentDidMount = () => {
		appActions.updateCurrentPage({ currentPage: 'landing' });
		$('.spinneroverlay').hide();
	}

	getFPTDATA = () =>{
		return {
			amount: appStore.getDonationAmount(),
			code: appStore.getDonationCode(),
			symbol: appStore.getDonationSymbol()
		}
	}

	handleGuest = (event) => {
		event.preventDefault();
		appActions.changeRecurringModalStatus({ recurringModalStatus: 'notclosed' });
		let donationAmount = appStore.getDonationAmount();
		let handleGuestObj = this;
		if (!this.validateDonationAmount()) {
			return;
		}
		if (donationAmount && parseFloat(donationAmount) >= 0.01) {
			setTimeout(() => {
				let isRPChecked = $("#recurringCheckbox").is(':checked');
				if (isRPChecked) {
					appActions.changeRecurring({
						recurring: "checked"
					});
					$('#signupInfo').modal('show');
				} else {
					handleGuest(handleGuestObj);
				}

				$('#signupInfo').one('hidden.bs.modal', function (e) {
					let recurringModalStatus = appStore.getRecurringModalStatus() === 'closed';
					if(recurringModalStatus){
						appActions.changeRecurringModalStatus({ recurringModalStatus: 'notclosed' });
						return;
					}

					let recurringStatus = appStore.getDonationRecurring() === 'checked';
					if(recurringStatus){
						handleGuestObj.setState({ rpContinue: true });
						handleGuest(handleGuestObj);
					}else{
						appActions.changeRecurring({
							recurring: "unchecked"
						});
						$('#recurringCheckbox').prop('checked', false);
						handleGuest(handleGuestObj);
					}
				})
			},10);
			// Tracking click event with data. 'Pay by card with amount'
			FPT.trackLinkClick('donateWithCard')
		} else {
			addShake();
		}
	}

	handleNext = (event) => {
		event.preventDefault();
		if (!this.validateDonationAmount()) {
			return;
		}

		let donationAmount = appStore.getDonationAmount()
		if (donationAmount && parseFloat(donationAmount) >= 0.01) {
			FPT.trackLinkClick('donateWithPayPal')
		}

		handleLogIn()
	}

	displayValidationError = () => {
		const errorMessage = amountUtils.getMinimumDonationErrorMessage(messages);
		this.setState({
			showValidationError: true,
			validationErrorMessage: errorMessage
		});
		addShake();
	}

	hideValidationError = () => {
		this.setState({
			showValidationError: false
		})
	}

	validateDonationAmount = () => {
		if (validateDonationAmountForUS()) {
			this.setState({
				showValidationError: false,
				validationErrorMessage: ''
			});
			return true;
		}
		this.displayValidationError();
		return false;
	}

	handleAmountFocus = () => {
		if (this.state.showValidationError) {
			this.hideValidationError();
		}
	}

	updateConversionSataus = (status = false) => {
		this.setState({ donateDisabled: status });
	}

	handleRecurringChange = (status = false) => {
		this.setState({ recurringStatus: status });
	}

	render () {
		return (
			<div className="donate_wrapper">
				<div className="container">
					{this.state.hasLogo ? <GlobalBanner /> : null}
					<SubHeader
						donationId={this.state.donationId}
						orgName={this.state.orgName}
						label={this.state.subHeaderLabel}/>
					<AmountWrapper
						conversionStatus={this.updateConversionSataus}
						validateDonationAmount={this.validateDonationAmount}
						showValidationError={this.state.showValidationError}
						hideValidationError={this.hideValidationError}
						validationErrorMessage={this.state.validationErrorMessage}
						onFocus={this.handleAmountFocus}
					/>
					{this.state.recurringEnabled && <RecurringCheckBox
														status={this.state.recurringStatus}
														handleChange={this.handleRecurringChange}
														showNote={false}
														hasRecurringHelp={true}
														continue={this.state.rpContinue}
													/>
					}
					<NextButton
						disabled={this.state.donateDisabled}
						handleNext={this.handleNext}/>
					<GuestButton
						disabled={this.state.donateDisabled}
						handleGuest={this.handleGuest}/>
					<CancelAndReturn />
				</div>
			</div>
		)
	}
}

LandingPage.contextTypes = {
	router: PropTypes.object.isRequired
};


class Landing extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			displayLanding: currentState ? false : true
		};
	}

	componentDidMount() {
		if (currentState) {
			this.context.router.push(currentState)
		} else {
			handleTokenReuse();
		}
	}

	render() {
		return (
			<div>
				{this.state.displayLanding ? <LandingPage /> : null}
			</div>
			)
	}
}

Landing.contextTypes = {
	router: PropTypes.object.isRequired
};

export default Landing



// WEBPACK FOOTER //
// ./pages/landing/landing.js